// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BottomModal_modal__THMoj {
  position: fixed;
  bottom: 0px;
  width: 100%;
  height: 50%;
  background: #d49000;
  box-shadow: 0 -4px 10px rgba(0, 0, 0, 0.2);
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  transition: bottom 0.5s ease-in-out;
  color: black;
  z-index: 9999;
  padding: 40px 20px 20px 20px;
  text-align: left;
  font-size: 16px;
  
}



.BottomModal_title__iSZ58 {
  font-weight: bold;
  margin-bottom: 10px;
}

.BottomModal_closeBtn__azEZl {
  position: absolute;
  top: 10px;
  right: 20px;
  font-size: 24px;
  cursor: pointer;
  color: #fff;
 
  
}


`, "",{"version":3,"sources":["webpack://./src/Components/BottomModal/BottomModal.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,WAAW;EACX,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,0CAA0C;EAC1C,4BAA4B;EAC5B,6BAA6B;EAC7B,mCAAmC;EACnC,YAAY;EACZ,aAAa;EACb,4BAA4B;EAC5B,gBAAgB;EAChB,eAAe;;AAEjB;;;;AAIA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;EACf,eAAe;EACf,WAAW;;;AAGb","sourcesContent":[".modal {\n  position: fixed;\n  bottom: 0px;\n  width: 100%;\n  height: 50%;\n  background: #d49000;\n  box-shadow: 0 -4px 10px rgba(0, 0, 0, 0.2);\n  border-top-left-radius: 20px;\n  border-top-right-radius: 20px;\n  transition: bottom 0.5s ease-in-out;\n  color: black;\n  z-index: 9999;\n  padding: 40px 20px 20px 20px;\n  text-align: left;\n  font-size: 16px;\n  \n}\n\n\n\n.title {\n  font-weight: bold;\n  margin-bottom: 10px;\n}\n\n.closeBtn {\n  position: absolute;\n  top: 10px;\n  right: 20px;\n  font-size: 24px;\n  cursor: pointer;\n  color: #fff;\n \n  \n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal": `BottomModal_modal__THMoj`,
	"title": `BottomModal_title__iSZ58`,
	"closeBtn": `BottomModal_closeBtn__azEZl`
};
export default ___CSS_LOADER_EXPORT___;
